import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Form, Input, Textarea } from "../../styles";
import AuthWrapper from "../../layout/AuthWrapper";
import Api from "../../api/axios";
import { encrypt } from "../../encrypt";
import { useLocalStorage } from "../../utils/useLocalStorage";
import { useUserContext } from "../../context/user_context";
import { useAuthContext } from "../../context/auth_context";
import { form } from "../../assets";

function CreateStore() {
  const [sending, setsending] = useState(false);

  const [bizData, setBizData] = useLocalStorage('businessData');
  const [storeData, setStoreData] = useLocalStorage('storeData');

  const { usertoken, btoken } = useUserContext();
  const {
    getBiz: { getBusinessData },
  } = useAuthContext();

  let navigate = useNavigate();

  // Form Fields
  const [formField, setformField] = useState({ name: '', address: '' });
  function handleChange(e) {
    setformField((inputs) => ({
      ...inputs,
      [e.target.name]: e.target.value,
    }));
  }
  // Form Fields

  //   Setup Store Function
  //   Setup Store Function
  function setupStore(e) {
    e.preventDefault();
    if (formField.name && formField.address && btoken) {

      setsending(true);

      const data = {
        storename: formField.name,
        location: formField.address,
        usertoken, btoken
      };

      Api.post(`/addStore`, data)
        .then((res) => {
          if (res.success === false) {
            toast.warn(res.message);
            setsending(false);
          } else {
            setsending(false);
            navigate("/user/dashboard");
            setStoreData(encrypt(res.data));
            setTimeout(() => {
              toast.success(res.message);
            }, 10);
          }
        })
        .catch((error) => {
          setsending(false);
        });
    } else {
      setsending(false);
      toast.warn("Empty Fields !!!");
    }
  }

  //   Setup Store Function
  //   Setup Store Function

  //  Get Business Details Function
  useEffect(() => {
    btoken && getBusinessData(btoken);
  }, 0);
  //  Get Business Details Function

  // Route to Create Biz if Btoken is not available in the local storage
  if (!btoken) {
    navigate("/create-business");
  }
  // Route to Create Biz if Btoken is not available in the local storage

  return (
    <>
      <AuthWrapper
        title='Add a Store / Branch'
        subTitle='Add a store / branch to your business'
        img={form}
      >
        <Form onSubmit={(e) => setupStore(e)}>
          <div className="row justify-content-center text-left">
            <div className="col-md-12 ">
              <label className="mb-0">Store Name:</label>
              <Input
                type="text"
                name="name"
                placeholder="e.g. Fireswitch Tech"
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-12 ">
              <label className="mb-0"> Store Address:</label>
              <Textarea
                type="text"
                name="address"
                placeholder="Address"
                onChange={handleChange}
                required
                autoComplete="false"
              />
            </div>

            <div className="col-md-12">
              <Button
                pry
                type="submit"
                disabled={sending}
                className="btn w-100"  >
                {sending ? 'loading...' : "Submit"}
              </Button>
              <div className="text-center mt-4">
                <small>
                  {" "}
                  By clicking the button above, you agree to our{" "}
                  <span className="pry-text">
                    <Link>Terms & Conditions</Link>
                  </span>{" "}
                  and{" "}
                  <span className="pry-text">
                    <Link>Privacy Policy </Link>
                  </span>{" "}
                  .
                </small>
              </div>
            </div>
          </div>
        </Form>
      </AuthWrapper>

    </>
  );
}

export default CreateStore;
